import { useLayoutEffect, useRef } from 'react';
import { cn } from '@/lib/utils';

/**
 * نص عادي (عنوان، سؤال...) بيتعدّل مكانه في وضع التعديل.
 * غير وضع التعديل بيرجع النص زي ما هو.
 */
const EditableText = ({ value, onChange, editing, as: Tag = 'span', className, placeholder, multiline = false }) => {
  const ref = useRef(null);

  // نحدّث المحتوى من برّه بس لو المستخدم مش بيكتب فيه (عشان المؤشر ما يتنططش)
  useLayoutEffect(() => {
    const el = ref.current;
    if (el && document.activeElement !== el && el.textContent !== (value ?? '')) {
      el.textContent = value ?? '';
    }
  }, [value, editing]);

  if (!editing) {
    return value ? <Tag className={className}>{value}</Tag> : null;
  }

  return (
    <Tag
      ref={ref}
      contentEditable
      suppressContentEditableWarning
      role="textbox"
      aria-label={placeholder}
      data-placeholder={placeholder}
      className={cn(className, 'page-editable')}
      onInput={(e) => onChange(e.currentTarget.textContent)}
      onKeyDown={(e) => {
        if (e.key === 'Enter' && !multiline) e.preventDefault();
      }}
      onPaste={(e) => {
        // لصق كنص عادي بدون تنسيق
        e.preventDefault();
        const text = e.clipboardData.getData('text/plain');
        document.execCommand('insertText', false, multiline ? text : text.replace(/\s*\n\s*/g, ' '));
      }}
    />
  );
};

export default EditableText;
